import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, FooterUI } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { ownerNameSelector } from 'selectors/current_organization';
const contentWrapperCss = "c1bgeg4v";
const ContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentWrapperCss, props.className)} />;
});
export const OrgConsolidationCompletePopup = () => {
  const ownerName = useSelector(ownerNameSelector);
  const [isOpen, setIsOpen] = useState(true);
  const onClose = () => {
    localStorage.setItem('calendly_user_consolidation_complete_popup', true);
    setIsOpen(false);
  };
  if (localStorage.getItem('calendly_user_consolidation_complete_popup')) {
    return null;
  }
  return <Popup isOpen={isOpen} onClose={onClose} title={HtmlParser(I18n.t('publisher.organization.consolidation.migration_complete_popup.title'))}>
      <ContentWrapper>
        {HtmlParser(I18n.t('publisher.organization.consolidation.migration_complete_popup.text', {
        org_name: ownerName
      }))}
      </ContentWrapper>
      <FooterUI>
        <Button onClick={onClose}>
          {HtmlParser(I18n.t('publisher.organization.consolidation.migration_complete_popup.button'))}
        </Button>
      </FooterUI>
    </Popup>;
};

require("./migration_complete_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./migration_complete_popup.js");